import { Stack } from '@/design-system/stack/stack';
import { Clock3 } from 'lucide-react';

export const VerificationPending = () => {
  return (
    <Stack space={4} align="center">
      <div className="h-10 w-10 rounded-lg bg-muted p-2.5">
        <Clock3 className="h-full w-full text-foreground" />
      </div>

      <Stack space={2} align="center">
        <h2 className="text-center text-lg font-medium text-foreground">Almost there...</h2>

        <p className="text-center text-sm font-normal text-muted-foreground">
          We're completing your account verification. This typically takes 3-5 business days and you'll be notified once
          your Treasury account is ready to use.
        </p>
      </Stack>
    </Stack>
  );
};
